import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import OtherPalletsList from "./views/OtherPalletsList";
import OtherPalletPropertiesPanel from "./panels/OtherPalletPropertiesPanel";
import {List} from "immutable";

class OtherPalletsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleSetContainerSelection = this.handleSetContainerSelection.bind(this);
    this.state = {
      palletId: "",
      hasPalletSelection: false,
      containerId: "",
      hasContainerSelection: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.route.page === "pallet" && this.props.route.page === "pallets") {
      this.setState({containerId: "", hasContainerSelection: false});
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Non-Water Pallets";
    if (page === "pallet") {
      title = `${title} / ${this.state.palletId}`;
    }

    return (
      <div className="OtherPalletsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "pallet"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Register Pallet" 
              onClick={this.handleRegisterPallet.bind(this)} />
            <ActionButton 
              label="Modify Pallet"
              active={this.state.hasPalletSelection}
              onClick={this.handleModifyPallet.bind(this)} />
          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      case "pallets":
        return (
          <OtherPalletsList 
            key="OtherPalletsList"
            selectedPalletId={this.state.palletId} 
            onSelectionChange={this.handleSetSelection}
            hasSelection={this.state.hasPalletSelection}
            />
        )

      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "pallets":
        return this.buildPanels(List([OtherPalletPropertiesPanel]));
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case OtherPalletPropertiesPanel:
        return <OtherPalletPropertiesPanel
                key="OtherPalletPropertiesPanel"
                expanded={this.props.route.page === "pallets"}
                selectedPalletId={this.state.palletId}
                hasSelection={this.state.hasPalletSelection}
                />
      default:
        return null;      
    }
  }

  handleSetSelection(id) {
    this.setState({palletId: id, hasPalletSelection: true});
  }

  handleSetContainerSelection(id, sku) {
    this.setState({containerId: id, hasContainerSelection: true});
  }

  handleModifyPallet() {
    this.props.requestModifyOtherPallet(this.state.palletId);
  }

  handleRegisterPallet() {
    this.props.requestRegisterOtherPallet();
  }

}


export default OtherPalletsPage;